(function () {
  "use strict";

  var isProductPage = window.isProductPage === true;
  var isCartPage = false;

  function isThisCartPage() {
    return /\/cart(\?|$|\/?$)/.test(window.location.pathname);
  }

  isCartPage = isThisCartPage();

  function formatMoney(cents, currencyCodeEnabled) {
    var amount = cents / 100;
    var formattedAmount = amount.toFixed(2);
    var parts = formattedAmount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    formattedAmount = parts.join(".");
    return window.shop_currency + " " + formattedAmount;
  }

  function formatMoneyDrawer(cents) {
    try {
      var amount = (parseInt(cents || 0, 10) / 100).toFixed(2);
      var parts = amount.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return window.shop_currency + " " + parts.join(".");
    } catch (e) {
      return window.shop_currency + " 0.00";
    }
  }

  function parseMoneyTextToCents(txt) {
    try {
      var m = (txt || "").match(/[\d'.,]+/);
      if (!m) return 0;
      var s = m[0].replace(/[']/g, "").replace(/,/g, "");
      return Math.round(parseFloat(s) * 100);
    } catch (e) {
      return 0;
    }
  }

  function saveDiscountPreference(discountTitle) {
    try {
      if (!discountTitle || discountTitle.trim() === "") {
        localStorage.setItem("activeDiscountTitle", "__no_discount__");
      } else {
        localStorage.setItem("activeDiscountTitle", discountTitle);
      }
    } catch (e) {
      console.error("[DEBUG] Error saving discount preference:", e);
    }
  }

  function getDiscountPreference() {
    try {
      var pref = localStorage.getItem("activeDiscountTitle");
      if (pref === "__no_discount__") {
        return "";
      }
      return pref || "";
    } catch (e) {
      console.error("[DEBUG] Error getting discount preference:", e);
      return "";
    }
  }

  function hasNoDiscountPreference() {
    try {
      return localStorage.getItem("activeDiscountTitle") === "__no_discount__";
    } catch (e) {
      console.error("[DEBUG] Error checking no-discount preference:", e);
      return false;
    }
  }

  function saveVariantDiscount(variantId, discountTitle, discountPercentage) {
    try {
      if (!variantId) {
        console.error("[DEBUG] saveVariantDiscount: No variantId provided");
        return;
      }
      var variantIdStr = String(variantId).trim();
      var variantDiscounts = {};
      var stored = localStorage.getItem("variantDiscounts");
      if (stored) {
        try {
          variantDiscounts = JSON.parse(stored);
        } catch (e) {
          console.error("[DEBUG] Error parsing stored variantDiscounts:", e);
          variantDiscounts = {};
        }
      }
      if (!discountTitle || discountTitle.trim() === "") {
        delete variantDiscounts[variantIdStr];
      } else {
        variantDiscounts[variantIdStr] = {
          title: discountTitle,
          percentage: discountPercentage || 0,
        };
      }
      localStorage.setItem(
        "variantDiscounts",
        JSON.stringify(variantDiscounts)
      );
    } catch (e) {
      console.error("[DEBUG] Error in saveVariantDiscount:", e);
    }
  }

  function getVariantDiscount(variantId) {
    try {
      var stored = localStorage.getItem("variantDiscounts");
      if (stored) {
        var variantDiscounts = JSON.parse(stored);
        var discount = variantDiscounts[variantId];
        if (discount) {
          return typeof discount === "string" ? discount : discount.title || "";
        }
      }
    } catch (e) {
      console.error("[DEBUG] Error getting variant discount:", e);
    }
    return "";
  }

  function getVariantDiscountData(variantId) {
    try {
      if (!variantId) {
        return null;
      }
      var variantIdStr = String(variantId).trim();
      var stored = localStorage.getItem("variantDiscounts");
      if (!stored) {
        return null;
      }
      var variantDiscounts = JSON.parse(stored);
      var discount = variantDiscounts[variantIdStr];
      if (discount && typeof discount === "object") {
        return discount;
      } else if (discount && typeof discount === "string") {
        return { title: discount, percentage: 0 };
      }
    } catch (e) {
      console.error("[DEBUG] Error in getVariantDiscountData:", e);
    }
    return null;
  }

  function getAssemblyPreference() {
    try {
      var lockedPreference = localStorage.getItem(
        "cartLockedDiscountPreference"
      );
      if (lockedPreference) {
        var lockedButtonNumber = parseInt(lockedPreference, 10);
        return lockedButtonNumber;
      }

      var preference = localStorage.getItem("assemblyPreference");
      return preference ? parseInt(preference, 10) : null;
    } catch (e) {
      console.error("[BUTTON] Error getting assembly preference:", e);
      return null;
    }
  }

  function isAssemblyBySkyPergola() {
    return getAssemblyPreference() === 2;
  }

  function calculateAndStoreButtonDiscountMapping(discounts) {
    try {
      if (!discounts || !Array.isArray(discounts) || discounts.length === 0) {
        return null;
      }

      var discountsWithPercentages = discounts
        .map(function (discount) {
          var percentage = 0;
          var discountValue = discount.value;

          if (discountValue) {
            if (discountValue.value !== undefined) {
              var value = parseFloat(discountValue.value);
              if (discountValue.type === "percentage") {
                if (value <= 1) {
                  percentage = value * 100;
                } else {
                  percentage = value;
                }
              } else {
                percentage = value * 100;
              }
            } else if (typeof discountValue === "number") {
              percentage =
                discountValue <= 1 ? discountValue * 100 : discountValue;
            } else if (typeof discountValue === "string") {
              var parsed = parseFloat(discountValue);
              percentage = parsed <= 1 ? parsed * 100 : parsed;
            }
          }

          return {
            title: discount.title || "",
            percentage: percentage,
            discount: discount,
          };
        })
        .sort(function (a, b) {
          return b.percentage - a.percentage;
        });

      if (discountsWithPercentages.length === 0) {
        return null;
      }

      var buttonMapping = {
        button1: discountsWithPercentages[0].title,
        button2:
          discountsWithPercentages.length >= 2
            ? discountsWithPercentages[1].title
            : discountsWithPercentages[0].title,
      };

      localStorage.setItem(
        "buttonDiscountMapping",
        JSON.stringify(buttonMapping)
      );

      return buttonMapping;
    } catch (e) {
      console.error("[BUTTON] Error calculating button discount mapping:", e);
      return null;
    }
  }

  function getButtonDiscountMapping() {
    try {
      var mapping = localStorage.getItem("buttonDiscountMapping");
      return mapping ? JSON.parse(mapping) : null;
    } catch (e) {
      console.error("[BUTTON] Error getting button discount mapping:", e);
      return null;
    }
  }

  function getDiscountForButton(buttonNumber, discounts) {
    try {
      if (!discounts || !Array.isArray(discounts) || discounts.length === 0) {
        return null;
      }

      var discountsWithPercentages = discounts
        .map(function (discount) {
          var percentage = 0;
          var discountValue = discount.value;

          if (discountValue) {
            if (discountValue.value !== undefined) {
              var value = parseFloat(discountValue.value);
              if (discountValue.type === "percentage") {
                if (value <= 1) {
                  percentage = value * 100;
                } else {
                  percentage = value;
                }
              } else {
                percentage = value * 100;
              }
            } else if (typeof discountValue === "number") {
              percentage =
                discountValue <= 1 ? discountValue * 100 : discountValue;
            } else if (typeof discountValue === "string") {
              var parsed = parseFloat(discountValue);
              percentage = parsed <= 1 ? parsed * 100 : parsed;
            }
          }

          return {
            title: discount.title || "",
            percentage: percentage,
            discount: discount,
          };
        })
        .sort(function (a, b) {
          return b.percentage - a.percentage;
        });

      if (discountsWithPercentages.length === 0) {
        return null;
      }

      if (buttonNumber === 1) {
        return discountsWithPercentages[0];
      } else if (buttonNumber === 2) {
        return discountsWithPercentages.length >= 2
          ? discountsWithPercentages[1]
          : discountsWithPercentages[0];
      }

      return null;
    } catch (e) {
      console.error("[BUTTON] Error getting discount for button:", e);
      return null;
    }
  }

  function cleanuplocalStorageForRemovedItems() {
    try {
      var hasDiscounts = localStorage.getItem("variantDiscounts");
      var hasRelationships = localStorage.getItem("variantRelationships");

      fetch("/cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          if (!cartData || !cartData.items || cartData.items.length === 0) {
            localStorage.removeItem("variantDiscounts");
            localStorage.removeItem("variantRelationships");
            localStorage.removeItem("cartLockedDiscountPreference");
            return;
          }

          if (!hasDiscounts && !hasRelationships) {
            return;
          }

          var variantIdsInCart = [];
          cartData.items.forEach(function (item) {
            if (item.variant_id) {
              variantIdsInCart.push(String(item.variant_id));
            }
          });

          try {
            var variantDiscountsStr = localStorage.getItem("variantDiscounts");
            if (variantDiscountsStr) {
              var variantDiscounts = JSON.parse(variantDiscountsStr);
              var hasChanges = false;
              for (var variantId in variantDiscounts) {
                if (variantIdsInCart.indexOf(variantId) === -1) {
                  delete variantDiscounts[variantId];
                  hasChanges = true;
                }
              }
              if (hasChanges) {
                localStorage.setItem(
                  "variantDiscounts",
                  JSON.stringify(variantDiscounts)
                );
              }
            }
          } catch (e) {
            console.error("[CLEANUP] Error cleaning variantDiscounts:", e);
          }

          try {
            var variantRelationshipsStr = localStorage.getItem(
              "variantRelationships"
            );
            if (variantRelationshipsStr) {
              var variantRelationships = JSON.parse(variantRelationshipsStr);
              var hasChanges = false;
              for (var mainVariantId in variantRelationships) {
                if (variantIdsInCart.indexOf(mainVariantId) === -1) {
                  delete variantRelationships[mainVariantId];
                  hasChanges = true;
                }
              }
              if (hasChanges) {
                localStorage.setItem(
                  "variantRelationships",
                  JSON.stringify(variantRelationships)
                );
              }
            }
          } catch (e) {
            console.error("[CLEANUP] Error cleaning variantRelationships:", e);
          }

          try {
            var noDiscountStr = localStorage.getItem("noDiscountVariants");
            if (noDiscountStr) {
              var noDiscountVariants = JSON.parse(noDiscountStr);
              var filtered = noDiscountVariants.filter(function (variantId) {
                return variantIdsInCart.indexOf(variantId) !== -1;
              });
              if (filtered.length !== noDiscountVariants.length) {
                if (filtered.length === 0) {
                  localStorage.removeItem("noDiscountVariants");
                } else {
                  localStorage.setItem(
                    "noDiscountVariants",
                    JSON.stringify(filtered)
                  );
                }
              }
            }
          } catch (e) {
            console.error("[CLEANUP] Error cleaning noDiscountVariants:", e);
          }
        })
        .catch(function (error) {
          console.error("[CLEANUP] Error fetching cart:", error);
        });
    } catch (e) {
      console.error("[CLEANUP] Error in cleanup function:", e);
    }
  }

  function findDiscountByTitle(discounts, title) {
    if (!discounts || !Array.isArray(discounts) || !title) {
      return null;
    }
    var titleStr = (title || "").trim();
    if (!titleStr) {
      return null;
    }
    var titles = titleStr
      .split(",")
      .map(function (t) {
        return t.trim();
      })
      .filter(function (t) {
        return t.length > 0;
      });
    if (titles.length === 0) {
      return null;
    }
    var exactMatches = [];
    var titlesLower = titles.map(function (t) {
      return t.toLowerCase();
    });
    discounts.forEach(function (d) {
      var discountTitle = (d.title || d.code || "").trim();
      var discountTitleLower = discountTitle.toLowerCase();
      for (var i = 0; i < titlesLower.length; i++) {
        if (discountTitleLower === titlesLower[i]) {
          exactMatches.push(d);
          break;
        }
      }
    });
    if (exactMatches.length === 0) {
      return null;
    }
    if (exactMatches.length === 1) {
      return exactMatches[0];
    }
    var bestMatch = exactMatches[0];
    var bestPercentage = bestMatch.percentage || 0;
    for (var i = 1; i < exactMatches.length; i++) {
      var candidatePercentage = exactMatches[i].percentage || 0;
      if (candidatePercentage > bestPercentage) {
        bestMatch = exactMatches[i];
        bestPercentage = candidatePercentage;
      }
    }
    return bestMatch;
  }

  function getActiveDiscountFromPage() {
    try {
      var activeButton = document.querySelector(".discount-button.active");
      if (activeButton) {
        var discountTitle =
          activeButton.getAttribute("data-discount-title") || "";
        if (discountTitle && discountTitle.trim() !== "") {
          return discountTitle.trim();
        }
      }
      return null;
    } catch (e) {
      console.error("[DEBUG] Error getting active discount from page:", e);
      return null;
    }
  }

  function getPriceContainer() {
    var selectors = [".price_list_wrapper"];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function getOriginalPrice() {
    var priceContainer = getPriceContainer();
    if (!priceContainer) return null;
    var variantPrice = priceContainer.getAttribute("data-variant-price");
    if (variantPrice) {
      return parseInt(variantPrice);
    }
    var comparePriceEl = priceContainer.querySelector(
      ".price--compare .amount"
    );
    var regularPriceEl = priceContainer.querySelector(".price .amount");

    if (!comparePriceEl) {
      console.error("No comparePriceEl or regularPriceEl found");
    }

    if (!regularPriceEl) {
      console.error("No regularPriceEl found");
    }

    var priceText =
      (comparePriceEl || regularPriceEl)?.textContent?.trim() || "";
    var priceMatch = priceText.match(/[\d'.,]+/);
    if (priceMatch) {
      var cleanPrice = priceMatch[0].replace(/[']/g, "").replace(",", ".");
      var price = parseFloat(cleanPrice) * 100;
      if (price && !isNaN(price)) {
        return price;
      }
    }
    try {
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (productJson) {
        var productData = JSON.parse(productJson);
        var variant =
          productData.variants?.find(function (v) {
            return v.available;
          }) || productData.variants?.[0];
        if (variant) {
          return parseInt(variant.price);
        }
      }
    } catch (e) {}
    return null;
  }

  function getVariantFromSelectedOptions() {
    try {
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (!productJson) {
        return null;
      }
      var productData = JSON.parse(productJson);

      var variants = productData.product?.variants || productData.variants;
      if (!variants || !Array.isArray(variants)) {
        return null;
      }

      var selectedOptions = [];

      var allSelectors = document.querySelectorAll(
        ".product-form__single-selector"
      );

      for (var i = 0; i < allSelectors.length; i++) {
        var selector = allSelectors[i];
        var isSelected = false;

        if (selector.type === "radio" || selector.type === "checkbox") {
          isSelected = selector.checked;
        } else if (selector.tagName === "SELECT") {
          isSelected = selector.selectedIndex >= 0;
        }

        if (isSelected) {
          var optionPosition =
            parseInt(selector.getAttribute("data-option-position")) || 1;
          var optionValue = selector.value;
          selectedOptions[optionPosition - 1] = optionValue;
        }
      }

      var matchingVariant = variants.find(function (variant) {
        for (var i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] === undefined || selectedOptions[i] === null) {
            continue;
          }
          var optionKey = "option" + (i + 1);
          if (variant[optionKey] !== selectedOptions[i]) {
            return false;
          }
        }

        var hasMatch = false;
        for (var i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] !== undefined && selectedOptions[i] !== null) {
            hasMatch = true;
            break;
          }
        }
        return hasMatch;
      });

      if (matchingVariant) {
        return matchingVariant;
      } else {
        return null;
      }
    } catch (e) {
      console.error(
        "[getVariantFromSelectedOptions] Error getting variant from options:",
        e
      );
      return null;
    }
  }

  function getCurrentVariantPrice() {
    var priceContainer = window.getPriceContainer();

    if (priceContainer) {
      var dataPrice = priceContainer.getAttribute("data-variant-price");

      if (dataPrice) {
        var parsed = parseInt(dataPrice);

        return parsed;
      }
    }

    try {
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (productJson) {
        var productData = JSON.parse(productJson);
        var variantIdInput = document.querySelector('[name="id"]');
        var variantId = variantIdInput ? variantIdInput.value : null;
        if (variantId) {
          var selectedVariant = productData.variants?.find(function (v) {
            return String(v.id) === String(variantId);
          });
          if (selectedVariant && selectedVariant.price) {
            return parseInt(selectedVariant.price);
          }
        }
      }
    } catch (e) {}

    var originalPrice = window.getOriginalPrice();

    return originalPrice;
  }

  function getDiscountPreferenceWithPriority() {
    try {
      var lockedPreference = localStorage.getItem(
        "cartLockedDiscountPreference"
      );
      if (lockedPreference) {
        var buttonNumber = parseInt(lockedPreference, 10);

        var buttonMapping = window.getButtonDiscountMapping();
        if (buttonMapping) {
          var discountTitle =
            buttonNumber === 1 ? buttonMapping.button1 : buttonMapping.button2;
          if (discountTitle) {
            return discountTitle;
          }
        }
      }

      var assemblyPref = localStorage.getItem("assemblyPreference");
      if (assemblyPref) {
        var buttonNumber = parseInt(assemblyPref, 10);
        var buttonMapping = window.getButtonDiscountMapping();
        if (buttonMapping) {
          var discountTitle =
            buttonNumber === 1 ? buttonMapping.button1 : buttonMapping.button2;
          if (discountTitle) {
            return discountTitle;
          }
        }
      }

      var activeDiscountTitle = window.getDiscountPreference();
      if (activeDiscountTitle && activeDiscountTitle.trim() !== "") {
        return activeDiscountTitle.trim();
      }

      var pageDiscount = window.getActiveDiscountFromPage();
      if (pageDiscount) {
        return pageDiscount;
      }

      return "";
    } catch (e) {
      console.error(
        "[getDiscountPreferenceWithPriority] Error getting discount preference:",
        e
      );
      return window.getDiscountPreference() || "";
    }
  }

  function resetToOriginalPrice() {
    var variantPrice = window.getCurrentVariantPrice();
    if (variantPrice) {
      updatePrice(null, variantPrice);
      updateAppliedDiscount(null);
    }
  }

  function interceptShopifyPriceUpdate() {
    if (!isProductPage) {
      return;
    }
    var variantSelects = document.querySelector(".product-form__variants");
    if (!variantSelects) return;
  }

  function initializeInterception() {
    if (!isProductPage) {
      return;
    }
    var variantSelects = document.querySelector(".product-form__variants");
    if (variantSelects) {
      window.interceptShopifyPriceUpdate();
    } else {
      setTimeout(initializeInterception, 100);
    }
  }

  let miniCartOpenedByUs = false;
  let clickOutsideHandler = null;
  let escapeKeyHandler = null;

  function closeMiniCart() {
    const miniCart = document.querySelector("#mini-cart");
    const toggleMiniCart = document.querySelector(
      "[data-action='toggle-mini-cart']"
    );
    const headerIconState = document.querySelector(
      ".header__cart-icon.icon-state"
    );

    miniCart?.setAttribute("aria-hidden", "true");
    toggleMiniCart?.setAttribute("aria-expanded", "false");
    headerIconState?.setAttribute("aria-expanded", "false");
    document.body.classList.remove("no-mobile-scroll");

    if (clickOutsideHandler) {
      document.removeEventListener("click", clickOutsideHandler);
      clickOutsideHandler = null;
    }
    if (escapeKeyHandler) {
      document.removeEventListener("keyup", escapeKeyHandler);
      escapeKeyHandler = null;
    }
    miniCartOpenedByUs = false;

    document.dispatchEvent(new CustomEvent("cart-drawer:close"));
  }

  function openMiniCart() {
    const miniCart = document.querySelector("#mini-cart");
    const toggleMiniCart = document.querySelector(
      "[data-action='toggle-mini-cart']"
    );
    const headerIconState = document.querySelector(
      ".header__cart-icon.icon-state"
    );
    const header = document.querySelector(".header");

    if (!miniCart && !toggleMiniCart && !headerIconState) return;

    if (miniCart?.getAttribute("aria-hidden") === "false") {
      closeMiniCart();
      return;
    }

    miniCart?.setAttribute("aria-hidden", "false");
    toggleMiniCart?.setAttribute("aria-expanded", "true");
    headerIconState?.setAttribute("aria-expanded", "true");
    document.body.classList.add("no-mobile-scroll");
    miniCartOpenedByUs = true;

    setTimeout(function () {
      clickOutsideHandler = function (event) {
        if (!miniCartOpenedByUs) return;

        const clickedInsideMiniCart =
          miniCart && miniCart.contains(event.target);
        const clickedInsideHeader = header && header.contains(event.target);

        if (!clickedInsideMiniCart && !clickedInsideHeader) {
          closeMiniCart();
        }
      };
      document.addEventListener("click", clickOutsideHandler);
    }, 0);

    escapeKeyHandler = function (event) {
      if (event.key === "Escape" && miniCartOpenedByUs) {
        closeMiniCart();
      }
    };
    document.addEventListener("keyup", escapeKeyHandler);

    document.dispatchEvent(new CustomEvent("cart-drawer:open"));
  }

  function updateBubbleCount(bubbleCount) {
    const bubbleCountElement = document.querySelector(".header__cart-count");
    if (!bubbleCountElement) return;
    bubbleCountElement.textContent = bubbleCount;
  }

  function recalculateMiniCartHeight() {
    try {
      var isMobile = window.innerWidth < 641;
      if (!isMobile) return;

      var miniCart = document.querySelector("#mini-cart");
      if (!miniCart) return;

      var isOpen = miniCart.getAttribute("aria-hidden") === "false";
      if (!isOpen) return;

      var header = document.querySelector(".header");
      if (!header) return;

      var maxHeight =
        window.innerHeight - header.getBoundingClientRect().bottom;
      miniCart.style.maxHeight = maxHeight + "px";

      var miniCartContent = miniCart.querySelector(".mini-cart__content");
      var miniCartRecap = miniCart.querySelector(".mini-cart__recap");

      if (miniCartContent && miniCartRecap) {
        miniCartContent.style.maxHeight =
          maxHeight - miniCartRecap.clientHeight + "px";
      }
    } catch (e) {
      console.error("[MINI-CART] Error recalculating height:", e);
    }
  }

  function updateMiniCartFromSections(
    sectionsData,
    { openDrawer = false, updateBubbleCount = false, cartData = null } = {}
  ) {
    console.log("updateMiniCartFromSections isCartPage", isCartPage);
    if (isCartPage) {
      return;
    }
    console.log(
      "updateMiniCartFromSections",
      sectionsData,
      openDrawer,
      updateBubbleCount,
      cartData
    );
    const sectionHTML =
      sectionsData?.sections?.["mini-cart"] || sectionsData?.["mini-cart"];

    if (!sectionHTML) {
      console.warn("Mini-cart section missing in response");
      return { ok: false, error: "no-mini-cart-in-response" };
    }

    const target =
      ["#mini-cart", "#shopify-section-mini-cart", '[data-section="mini-cart"]']
        .map((s) => document.querySelector(s))
        .find(Boolean) || null;

    if (!target) {
      console.warn("Mini-cart element not found in DOM");
      return { ok: false, error: "no-mini-cart-element" };
    }

    const temp = document.createElement("div");
    temp.innerHTML = sectionHTML;

    const newMiniCart =
      [
        "#mini-cart",
        "#shopify-section-mini-cart",
        '[data-section="mini-cart"]',
        "form",
      ]
        .map((s) => temp.querySelector(s))
        .find(Boolean) ||
      temp.firstElementChild ||
      null;

    if (!newMiniCart) {
      console.warn("No mini-cart node found in parsed HTML");
      return { ok: false, error: "parsed-html-empty" };
    }

    const oldLineItemList = target.querySelector(".mini-cart__line-item-list");
    const scrollPosition = oldLineItemList ? oldLineItemList.scrollTop : 0;

    const oldInner = target.querySelector(".mini-cart__inner");
    const newInner = newMiniCart.querySelector(".mini-cart__inner");

    if (oldInner && newInner) {
      oldInner.innerHTML = newInner.innerHTML;
    } else {
      target.innerHTML = newMiniCart.innerHTML;
    }

    const newLineItemList = target.querySelector(".mini-cart__line-item-list");
    if (newLineItemList && scrollPosition > 0) {
      newLineItemList.scrollTop = scrollPosition;
    }

    recalculateMiniCartHeight();

    const newCount =
      newMiniCart.getAttribute("data-item-count") ||
      newMiniCart
        .querySelector("[data-item-count]")
        ?.getAttribute("data-item-count");

    if (newCount != null) {
      target.setAttribute("data-item-count", newCount);
    }

    document.dispatchEvent(new CustomEvent("cart:refresh"));

    if (updateBubbleCount) {
      window.updateBubbleCount(newCount);
    }

    if (openDrawer) {
      openMiniCart();

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
      }, 100);
    } else {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
      }, 100);
    }

    if (typeof window.applyCartDrawerDiscounts === "function") {
      setTimeout(() => {
        console.log(
          "[MINI-CART] Calling applyCartDrawerDiscounts after DOM update"
        );
        window.applyCartDrawerDiscounts();

        setTimeout(() => {
          if (typeof window.recomputeDrawerSubtotalFromDOM === "function") {
            window.recomputeDrawerSubtotalFromDOM();
          }
        }, 200);
      }, 300);
    } else {
      console.warn("[MINI-CART] applyCartDrawerDiscounts not available");
    }

    return { ok: true };
  }

  var cartInteractionSelectors = [
    "form.cart-recap button[name='checkout']",
    '.mini-cart__button-container button[name="checkout"]',
    ".mini-cart__button-container a.button.button--secondary",
    '[data-essential-upsell-element="add-to-cart-button"]',
    ".discount-pill-remove",
    ".quantity.cart-update",
    ".quantity-selector",
    ".remove.mini-cart__quantity-remove.link",
    ".remove.line-item__quantity-remove.link",
  ];

  var cartMutationObserver = null;

  window._cartInteractionLockCount =
    typeof window._cartInteractionLockCount === "number"
      ? window._cartInteractionLockCount
      : 0;
  window._cartInteractionLockSources = window._cartInteractionLockSources || [];

  function applyDisabledStateToElements() {
    cartInteractionSelectors.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        if (!el.classList.contains("disabled")) {
          el.classList.add("disabled");
          el.setAttribute("data-was-interactive", "true");
        }
      });
    });
  }

  function removeDisabledStateFromElements() {
    cartInteractionSelectors.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        el.classList.remove("disabled");
        el.removeAttribute("data-was-interactive");
      });
    });
  }

  function startCartMutationObserver() {
    if (cartMutationObserver) return;

    var miniCart = document.querySelector("#mini-cart");
    if (!miniCart) return;

    cartMutationObserver = new MutationObserver(function (mutations) {
      if (window._cartInteractionLockCount <= 0) return;

      var shouldReapply = mutations.some(function (mutation) {
        return (
          mutation.type === "childList" &&
          (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)
        );
      });

      if (shouldReapply) {
        applyDisabledStateToElements();
      }
    });

    cartMutationObserver.observe(miniCart, {
      childList: true,
      subtree: true,
    });
  }

  function stopCartMutationObserver() {
    if (cartMutationObserver) {
      cartMutationObserver.disconnect();
      cartMutationObserver = null;
    }
  }

  function disableCartInteractions(functionCalledFromLineX) {
    window._cartInteractionLockCount++;
    window._cartInteractionLockSources.push(functionCalledFromLineX);

    console.log(
      "[CART-INTERACTIONS] Disabled from:",
      functionCalledFromLineX,
      "| Lock count:",
      window._cartInteractionLockCount,
      "| Active locks:",
      window._cartInteractionLockSources.slice()
    );

    window._cartInteractionsDisabled = true;

    applyDisabledStateToElements();

    startCartMutationObserver();
  }

  function enableCartInteractions(functionCalledFromLineX) {
    var sourceIndex = window._cartInteractionLockSources.indexOf(
      functionCalledFromLineX
    );
    if (sourceIndex === -1) {
      var prefix = functionCalledFromLineX.split(" ")[0];
      for (var i = 0; i < window._cartInteractionLockSources.length; i++) {
        if (window._cartInteractionLockSources[i].indexOf(prefix) === 0) {
          sourceIndex = i;
          break;
        }
      }
    }

    if (sourceIndex !== -1) {
      window._cartInteractionLockSources.splice(sourceIndex, 1);
    }

    window._cartInteractionLockCount = Math.max(
      0,
      window._cartInteractionLockCount - 1
    );

    console.log(
      "[CART-INTERACTIONS] Enable requested from:",
      functionCalledFromLineX,
      "| Lock count:",
      window._cartInteractionLockCount,
      "| Remaining locks:",
      window._cartInteractionLockSources.slice()
    );

    if (window._cartInteractionLockCount <= 0) {
      console.log(
        "[CART-INTERACTIONS] All locks released - enabling interactions"
      );
      window._cartInteractionsDisabled = false;
      window._cartInteractionLockCount = 0;
      window._cartInteractionLockSources = [];

      stopCartMutationObserver();
      removeDisabledStateFromElements();
    }
  }

  function forceEnableCartInteractions(functionCalledFromLineX) {
    console.log(
      "[CART-INTERACTIONS] FORCE enabled from:",
      functionCalledFromLineX,
      "| Was lock count:",
      window._cartInteractionLockCount
    );

    window._cartInteractionLockCount = 0;
    window._cartInteractionLockSources = [];
    window._cartInteractionsDisabled = false;

    stopCartMutationObserver();
    removeDisabledStateFromElements();
  }

  window.formatMoney = formatMoney;
  window.formatMoneyDrawer = formatMoneyDrawer;
  window.parseMoneyTextToCents = parseMoneyTextToCents;
  window.saveDiscountPreference = saveDiscountPreference;
  window.getDiscountPreference = getDiscountPreference;
  window.hasNoDiscountPreference = hasNoDiscountPreference;
  window.saveVariantDiscount = saveVariantDiscount;
  window.getVariantDiscount = getVariantDiscount;
  window.getVariantDiscountData = getVariantDiscountData;
  window.getAssemblyPreference = getAssemblyPreference;
  window.isAssemblyBySkyPergola = isAssemblyBySkyPergola;
  window.calculateAndStoreButtonDiscountMapping =
    calculateAndStoreButtonDiscountMapping;
  window.getButtonDiscountMapping = getButtonDiscountMapping;
  window.getDiscountForButton = getDiscountForButton;
  window.cleanuplocalStorageForRemovedItems =
    cleanuplocalStorageForRemovedItems;
  window.findDiscountByTitle = findDiscountByTitle;
  window.getActiveDiscountFromPage = getActiveDiscountFromPage;
  window.getPriceContainer = getPriceContainer;
  window.getOriginalPrice = getOriginalPrice;
  window.getVariantFromSelectedOptions = getVariantFromSelectedOptions;
  window.getCurrentVariantPrice = getCurrentVariantPrice;
  window.getDiscountPreferenceWithPriority = getDiscountPreferenceWithPriority;
  window.resetToOriginalPrice = resetToOriginalPrice;
  window.interceptShopifyPriceUpdate = interceptShopifyPriceUpdate;
  window.initializeInterception = initializeInterception;
  window.updateMiniCartFromSections = updateMiniCartFromSections;
  window.recalculateMiniCartHeight = recalculateMiniCartHeight;
  window.openMiniCart = openMiniCart;
  window.closeMiniCart = closeMiniCart;
  window.updateBubbleCount = updateBubbleCount;
  window.disableCartInteractions = disableCartInteractions;
  window.enableCartInteractions = enableCartInteractions;
  window.forceEnableCartInteractions = forceEnableCartInteractions;
  window.isThisCartPage = isThisCartPage;
})();
